<mat-toolbar #ariaToolbar
  [ngClass]="{'hide-toolbar': !HTML_VisibilityToolbar}"
  id="id-main-toolbar"
  class="horizontal-scollable"
  [ngStyle]="{'background': armaorStyleColor}">
  <mat-toolbar-row>
    <!-- Logo cliquable armaor -->

    <input *ngIf="visibilityElement?.ArmaorLogo"
      class="armaor-logo"
      type="image"
      src="assets/armaor-logo.png"
      (click)="onArmaorLogoClick()"
      matTooltip="{{'Accueil' | translate}}">

    <!-- List de bouton afficher au début de la toolbar -->
    <ng-container *ngIf="visibilityElement?.ArrayStartBtn;">
      <div *ngFor="let item of CST_ARRAY_TOOLBAR_START_BTN">
        <button mat-button mat-raised-button
          color="{{item.color}}"
          (click)="onBtnClick(item)"
          [disabled]="HTML_LOCK_BTN || item.btnDisabled">
            {{item.name | translate}}
        </button>
      </div>
    </ng-container>
    <span class="filler"></span>
    <!-- Titre de la toolbar -->
    <div *ngIf="visibilityElement?.Title" style="color: white">{{HTML_PageTitle | translate}}</div>
    <span class="filler"></span>
    <!-- Select utiliser pour choisir le chantier -->
    <ng-container *ngIf="visibilityElement?.SiteSelect">
      <div class="site-zone-selector" *ngIf="arraySite?.length > 0">
        {{ 'Chantier' | translate }} :
        <site-selector [disabled]="HTML_LOCK_BTN" (onSiteCodeChange)="onSiteChange($event)"></site-selector>
      </div>
    </ng-container>
    <!-- List de bouton afficher a la fin de la toolbar -->
    <ng-container *ngIf="visibilityElement?.ArrayEndBtn">
      <div *ngFor=" let item of CST_ARRAY_TOOLBAR_END_BTN">
        <button mat-button mat-raised-button
          color="{{item.color}}"
          (click)="onBtnClick(item)"
          [disabled]="HTML_LOCK_BTN">
            {{item.name | translate}}
        </button>
      </div>
    </ng-container>
    <!-- Bouton pour afficher le menu -->
    <button *ngIf="visibilityElement?.MenuBtn" mat-button mat-raised-button [matMenuTriggerFor]="menu" (menuOpened)="menuOpened()" [disabled]="HTML_LOCK_BTN">{{'Menu' | translate}}</button>
  </mat-toolbar-row>
</mat-toolbar>

<!-- Menu de la toolbar -->
<mat-menu #menu="matMenu">

  <button mat-menu-item [routerLink]="[ '/home' ]">
    <mat-icon>home</mat-icon>
    <span>{{'Accueil' | translate}}</span>
  </button>

  <mat-divider></mat-divider>

  <ng-container *ngFor="let item of HTML_ArrayHomeScreenItem">
    <button mat-menu-item
            [matTooltip]="item.content"
            matTooltipPosition="before"
            matTooltipShowDelay="500"
            *ngIf="item.visible"
            (click)="item.onClickEventFunc()">
      <img class="mat-icon" width="24px" [src]="item.imageSrc">
      <span>{{item.title | translate}}</span>
    </button>
  </ng-container>

  <mat-divider></mat-divider>

  <button mat-menu-item (click)="onParamClick()">
    <mat-icon>settings</mat-icon>
    <span>{{'Parametres' | translate}}</span>
  </button>

  <button mat-menu-item class="warn-menu-item" (click)="onLogOutClick()">
    <mat-icon>logout</mat-icon>
    <span>{{'Déconnexion' | translate}}</span>
  </button>

  <mat-divider></mat-divider>
  <span mat-menu-item disabled="true" style="pointer-events: all;">
    <app-select-language style="padding: 0" mat-subheader></app-select-language>
  </span>
</mat-menu>
